import { ForumError, forumEnvelope, forumError, invalidResponse, staleResponse } from './forumErrors';
import { forumId } from '../models/forumMappers';
import { publicationResult } from '../models/forumComposer';

export function publicationCommand({ context, value, requestId }) {
  if (!context || !value || !/^[1-9]\d{9}_[a-f0-9]{32}$/.test(requestId || '')) throw invalidResponse();
  const operation = context.mode === 'create' ? 'create' : context.mode === 'reply' ? 'reply'
    : context.mode === 'edit' && ['topic', 'comment'].includes(context.postType) ? 'edit_' + context.postType : null;
  if (!operation) throw invalidResponse();
  const payload = { html: value.html, attachment_ids: value.attachmentIds || [] };
  if (operation === 'create') { payload.title = value.title; payload.section_id = forumId(value.sectionId); if (!payload.section_id) throw invalidResponse(); }
  else {
    payload.thread_id = forumId(context.threadId); if (!payload.thread_id) throw invalidResponse();
    if (operation === 'reply') { payload.quote_id = forumId(value.quoteId); }
    else {
      payload.post_id = forumId(context.postId); if (!payload.post_id) throw invalidResponse();
      if (operation === 'edit_topic') { if (payload.post_id !== payload.thread_id) throw invalidResponse(); payload.title = value.title; }
    }
  }
  return { operation, request_id: requestId, payload };
}

export function createForumPublicationRepository({ http, readHttp, getIdentity, onPublished = () => {} }) {
  const key = () => JSON.stringify(getIdentity() || {});
  function owner() { if (!forumId((getIdentity() || {}).uid)) throw new ForumError('authentication_required', 'Inicia sesión para publicar.', 401); return key(); }
  function assertOwner(expected) { if (key() !== expected) throw staleResponse(); }
  function confirmation(data, context) {
    const raw = data && data.result;
    const result = raw && publicationResult({ threadId: forumId(raw.thread_id), postId: forumId(raw.post_id), postType: raw.post_type }, context);
    if (!result) throw invalidResponse();
    // Cache invalidation must not turn a confirmed publication into an uncertain
    // send. The reader also explicitly reloads the authoritative destination.
    try { onPublished(result); } catch (_) { /* confirmation remains authoritative */ }
    return result;
  }
  return {
    async publish(command) {
      const expected = owner(), payload = publicationCommand(command);
      try {
        const response = await http.post('/forum/api/v2/publications', payload); assertOwner(expected);
        const data = forumEnvelope(response.data).data;
        if (data.state === 'pending') throw new ForumError('publication_pending', 'El envío sigue pendiente. Comprueba su estado.');
        if (data.state !== 'published') throw invalidResponse();
        return confirmation(data, command.context);
      } catch (error) { assertOwner(expected); throw forumError(error); }
    },
    async checkSubmission({ context, requestId }) {
      const expected = owner();
      if (!/^[1-9]\d{9}_[a-f0-9]{32}$/.test(requestId || '')) throw invalidResponse();
      try {
        const response = await readHttp.get('/forum/api/v2/submissions/' + requestId); assertOwner(expected);
        const data = forumEnvelope(response.data).data;
        if (data.state === 'published') return { state: 'published', result: confirmation(data, context) };
        if (data.state === 'rejected' && data.error && data.error.code === 'publication_rejected' && [400, 403, 404, 422].includes(data.error.status)) return { state: 'rejected' };
        if (['pending', 'missing'].includes(data.state)) return { state: data.state };
        throw invalidResponse();
      } catch (error) { assertOwner(expected); throw forumError(error); }
    }
  };
}
